import { supabase } from "@/lib/supabaseClient";

export type AuditAction =
  | "login"
  | "logout"
  | "impersonation_start"
  | "impersonation_end"
  | "contract_signed"
  | "addon_activated"
  | "addon_disabled"
  | "addon_reactivated"
  | "payment_created"
  | "payment_voided"
  | "payment_deleted"
  | "job_created"
  | "job_updated"
  | "job_status_changed"
  | "job_deleted"
  | "module_activated"
  | "module_deactivated"
  | "domain_approved"
  | "domain_rejected"
  | "domain_active"
  | "client_created"
  | "client_updated"
  | "client_deleted"
  | "contract_created"
  | "contract_updated"
  | "contract_deleted"
  | "tenant_created"
  | "tenant_updated"
  | "tenant_status_changed"
  | "tenant_plan_changed";

export type AuditEntity =
  | "user"
  | "tenant"
  | "client"
  | "contract"
  | "payment"
  | "job"
  | "module"
  | "domain"
  | "digital_invitation"
  | "addon"
  | "signature_book";

export type AuditSeverity = "info" | "warning" | "critical";

interface LogAuditParams {
  tenantId?: string | null;
  action: AuditAction;
  entity?: AuditEntity;
  entityId?: string;
  entityName?: string;
  details?: Record<string, unknown>;
  severity?: AuditSeverity;
}

/**
 * Insert an audit log entry. Silent fail — audit logs are non-critical.
 * Includes current user_id and email automatically.
 */
export async function logAudit({
  tenantId,
  action,
  entity,
  entityId,
  entityName,
  details,
  severity = "info",
}: LogAuditParams): Promise<void> {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    await supabase.from("audit_logs").insert({
      tenant_id: tenantId ?? null,
      user_id: user?.id ?? null,
      user_email: user?.email ?? null,
      action,
      entity: entity ?? null,
      entity_id: entityId ?? null,
      entity_name: entityName ?? null,
      details: details ?? null,
      severity,
    });
  } catch {
    // Silent fail — audit logs must never break the main flow
  }
}